// @ts-nocheck aeb02142
import * as fontUtils from './fontUtils';
import _ from 'lodash';
import { fedopsLogger } from '#packages/util';

function insertUploadedFontsToCk(fontNamesArr, textManager) {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line you-dont-need-lodash-underscore/filter
  _(fontNamesArr)
    .filter(function (name) {
      return fontUtils.isUploadedFont(name);
    })
    .forEach(function (cssName) {
      textManager.execCommand('wixCss', {
        id: cssName,
        value: fontUtils.getUploadedFontFace([cssName]),
      });
    });
}

function expandSelectionToLinks(textManager) {
  textManager.commands.expandCurrentLinkSelection();
}

//todo: text limit utils
function focus(editor) {
  const sel = editor.getSelection();
  sel.ignoreFillingCharRemoveOnSelectionChange();
  editor.focus();
  sel.resumeFillingCharRemoveOnSelectionChange();
}

function toggleSelectionToTransparent(textManager, shouldEnable) {
  textManager.toggleSelectionToTransparent(shouldEnable);
}

function setOverflowCss(textManager) {
  textManager.execCommand('wixCss', {
    id: 'overFlowCss',
    value: 'body {overflow: hidden !important;}',
    isLink: false,
    force: false,
  });
}

function removeOverflowCss(textManager) {
  textManager.execCommand('wixCss', {
    id: 'overFlowCss',
    value: '',
    isLink: false,
    force: false,
  });
}

function registerAfterUndoRedoListener(callback, isUndo, textManager) {
  const snapshot = textManager.getRawData();
  const listener = function () {
    if (_.isEqual(snapshot, textManager.getRawData())) {
      callback();
    }
  };

  if (isUndo) {
    textManager.onAfterUndo(listener);
  } else {
    textManager.onAfterRedo(listener);
  }

  return listener;
}

function setCkReadOnly(textManager, isReadOnly) {
  textManager.setReadOnly(isReadOnly);
}

/**
 * This is temporary solution for a corruption we had with AI, that inserted the class `wixGuard` in spans that are not empty.
 * https://jira.wixpress.com/browse/WEED-32102
 * Should be removed once we see that fedops is not reporting this issue anymore.
 * @param textValue
 */
const removeFaultyWixGuard = (textValue: string) => {
  const hasNoWixGuardClass = !textValue.includes('wixGuard');
  if (hasNoWixGuardClass) {
    return textValue;
  }
  fedopsLogger.interactionStarted(
    fedopsLogger.INTERACTIONS.SMART_WRITER_TEXT_EDITING_REMOVE_FAULTY_WIX_GUARD,
  );
  const regex =
    /(<span\s+class\s*=\s*")((?:\s*wixGuard\s+|\s*)((?:[^"]+\s+)?wixGuard(?:\s+[^"]+)?))"(?=[^>]*>(?!&ZeroWidthSpace;))/g;
  const replacement = (_, openingTag, classes) => {
    return `${openingTag + classes.replace(/\s*wixGuard\s*/, ' ').trim()}"`;
  };
  const newTextValue = textValue.replace(regex, replacement);
  fedopsLogger.interactionEnded(
    fedopsLogger.INTERACTIONS.SMART_WRITER_TEXT_EDITING_REMOVE_FAULTY_WIX_GUARD,
  );
  return newTextValue;
};

export {
  focus,
  toggleSelectionToTransparent,
  registerAfterUndoRedoListener,
  setOverflowCss,
  removeOverflowCss,
  setCkReadOnly,
  expandSelectionToLinks,
  insertUploadedFontsToCk,
  removeFaultyWixGuard,
};
